import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ContactType, layoutOptions } from "./types/prop-types";

/** Contact Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: SecondaryBlockSize.ExtraSmall,
};

export const Contact = secondaryBlock<ContactType>(
  blockConfig,
  ({
    primaryButtonText,
    primaryButtonLink,
    secondaryButtonText,
    secondaryButtonLink,
    tertiaryButtonText,
    tertiaryButtonLink,
    layoutProps,
    icon,
    linkText,
    link,
    text1,
    text2,
  }: ContactType) => {
    const hasButtons =
      primaryButtonText || secondaryButtonText || tertiaryButtonText;

    return (
      <Box className="secondary-contact-extrasmall-v1">
        <Variants.ButtonGroup
          primaryButtonText={primaryButtonText}
          primaryButtonLink={primaryButtonLink}
          secondaryButtonText={secondaryButtonText}
          secondaryButtonLink={secondaryButtonLink}
          tertiaryButtonText={tertiaryButtonText}
          tertiaryButtonLink={tertiaryButtonLink}
        />
        <Box className="w-layout-grid list-component-xsmall">
          <Box
            sx={{ marginTop: hasButtons ? "2.5rem" : "0" }}
            className="list-item-xsmall item-xsmall"
          >
            <Box
              id="w-node-_1954312c-9b15-825a-d035-e50cd5caf226-dfb6ca09"
              className="item-xsmall"
            >
              {icon && (
                <Box className="icon-wrapper padding-right-xsmall w-embed">
                  <Variants.IconTiny
                    hasBg={layoutProps.hasIconBackground}
                    icon={icon}
                  />
                </Box>
              )}
              <Variants.ParagraphTiny>
                <Variants.ParagraphTiny className="text">
                  {text1}{" "}
                </Variants.ParagraphTiny>
                <Variants.LinkUnderline
                  as="strong"
                  sx={{ fontWeight: "bold" }}
                  href={link}
                >
                  {linkText}
                </Variants.LinkUnderline>{" "}
                {text2}
              </Variants.ParagraphTiny>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
);

Contact.defaultProps = getDefaultProps<ContactType>(defaults);

export const Element: KameleonElement = {
  component: Contact,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
